export const getTimeToWait = (seconds) => {
    const minutes = Math.floor(seconds / 60);

    if (minutes > 1 && minutes < 60) {
        return { time: minutes.toString(), timeUnitType: 'MINUTES' };
    } else if (minutes >= 60) {
        const timeInHours = Math.round(seconds / 3600);
        return timeInHours === 1 ? { time: timeInHours.toString(), timeUnitType: 'HOUR' } : { time: timeInHours.toString(), timeUnitType: 'HOURS' };
    } else {
        return { time: seconds.toString(), timeUnitType: 'SECONDS' };
    }
};

export default function collateErrors(values, props, json) {
    let errors = {};
    const { messages, loginSectionName, change } = props;

    const consentFieldName = loginSectionName ? `${loginSectionName}.externalConsentsProvided` : 'externalConsentsProvided';
    change(consentFieldName, undefined);

    if (json && json.errors) {
        json.errors.forEach(({ errorKey, ...rest }) => {
            switch (errorKey) {
                case '_ERR_AUTHENTICATION_ERROR':
                    errors._error = messages.errors.authenticationError();
                    break;
                case '_ERR_LOGIN_NOT_ALLOWED_NOW': {
                    const { errorParameters: timeToWait } = rest;
                    const { time, timeUnitType } = getTimeToWait(timeToWait);
                    const timeUnit = messages.errors.timeUnit({ type: timeUnitType });
                    errors._error = messages.errors.loginNotAllowed({ time, timeUnit });
                    break;
                }
                case 'ERR_TOS_CONSENT_OLD_DATE_ACCEPTANCE_FOR_USER':
                case 'ERR_CONSENT_NOT_ACCEPTED':
                    change(consentFieldName, false);
                    break;
                default:
                    errors._error = messages.errors.global();
                    break;
            }
        });
    }

    return { _error: messages.errors.global(), ...errors };
}
